import {Button, IconButton} from "@mui/material";
import {useEffect} from "react";
import {FiPlus, FiTrash2} from "react-icons/fi";
import {useNavigate} from "react-router-dom";
import ListView from "../components/ListView/ListView";
import Window from "../components/Window/Window";
import ConfirmDialog from "../components/ui/ConfirmDialog";
import {scopesColumns} from "../constants/dataGridColumns";
import useApiRequest from "../hooks/useApiRequest";
import useConfirmDialog from "../hooks/useConfirmDialog";
import LoadingContent from "../components/ui/LoadingContent";

const Scopes = () => {
  const navigate = useNavigate();
  const {data, loading, list, remove} = useApiRequest({baseUrl: "/scopes", resource: "scopes"});

  const {confirmOpen, itemName, openDialog, handleConfirm, handleCancel} = useConfirmDialog(async (id) => {
    try {
      await remove(id);
      await list();
    } catch (error) {
      console.error("Error al eliminar el scope:", error);
    }
  });
  useEffect(() => {
    (async () => {
      try {
        await list();
      } catch (error) {
        console.error("Error al cargar los scopes:", error);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleScopeClick = (scope) => {
    if (!scope?.id) {
      console.error("Error: No se encuentra el scope");
      return;
    }
    navigate(`/scope-form`, {state: {id: scope?.id}});
  };

  const handleOpenDeleteDialog = (id) => {
    const found = Array.isArray(data) ? data.find((scope) => scope.id === id) : null;
    openDialog(id, found?.name || "");
  };

  const columns = [
    ...scopesColumns,
    {
      field: "actions",
      headerName: "Actions",
      width: 150,
      sortable: false,
      filterable: false,
      renderCell: (params) => {
        return (
          <IconButton
            aria-label="delete"
            color="error"
            onClick={(e) => {
              e.stopPropagation();
              handleOpenDeleteDialog(params.row.id);
            }}
          >
            <FiTrash2 />
          </IconButton>
        );
      }
    }
  ];

  return (
    <>
      <Window
        title={"Scopes"}
        topRightButtons={
          <Button
            variant="contained"
            color="primary"
            startIcon={<FiPlus />}
            onClick={() => {
              navigate(`/scope-form`);
            }}
          >
            Nuevo Scope
          </Button>
        }
      >
        {loading ? (
          <LoadingContent />
        ) : (
          <ListView columns={columns} data={data} loading={loading} onRowClick={handleScopeClick} />
        )}
      </Window>

      <ConfirmDialog
        open={confirmOpen}
        onClose={handleCancel}
        onConfirm={handleConfirm}
        entityName="scope"
        entityLabel={itemName}
      />
    </>
  );
};

export default Scopes;
